"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./SubNavHeading.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavHeading = function SubNavHeading(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      separator = _ref.separator;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "subNavHeading-wrapper",
    style: {
      boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.15)"
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "subNavHeading-bold",
    "data-testid": "nav-heading"
  }, heading), "\xA0", /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "nav-seperator"
  }, separator), "\xA0", /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "nav-subHeading"
  }, subHeading));
};

var _default = SubNavHeading;
exports.default = _default;